import getCurrentUserSelector from 'modules/users/selectors/get-current'
import { createSelector } from 'reselect'
import shouldShowNewsletterSelect from 'modules/newsletter/redux/selectors/should-show/index.js'
import { hasCartProductsSelector } from 'modules/cart/selectors/index.js'
import getMatchRouterSelect from 'modules/router/selectors/get-match/index.js'
import getPathnameRouterSelect from 'modules/router/selectors/get-pathname/index.js'
import { ROUTE_PATH_WITH_CUSTOM_SIDEBAR } from 'modules/routes/constants/index.cjs'
import { isEditingRoutesSelector } from 'modules/routes/selectors/is-editing/index.js'

export const shouldShowSidebarSelect = createSelector(
  shouldShowNewsletterSelect,
  getCurrentUserSelector(),
  hasCartProductsSelector(),
  getMatchRouterSelect,
  getPathnameRouterSelect,
  isEditingRoutesSelector(),
  (
    shouldShowNewsletter,
    currentUser,
    hasCartProducts,
    match,
    pathname,
    isEditing
  ) => {
    if (isEditing) {
      return false
    }

    if (
      currentUser &&
      pathname.startsWith(ROUTE_PATH_WITH_CUSTOM_SIDEBAR.ORDERS) &&
      match?.params?.key
    ) {
      return true
    }

    if (
      currentUser &&
      hasCartProducts
    ) {
      return true
    }

    return !!shouldShowNewsletter
  }
)
